<template>
  <Spinner v-if="loading.view"></Spinner>
  <ui-content v-else title="Biblia Registros">
    <Card title="General">
      <template #toolbar>
        <button
          class="btn btn-sm btn-primary shadow"
          @click="onClickGuardarCabecera"
          :disabled="loading.header_save"
        >
          Guardar
        </button>
        <button
          v-if="containers.biblia"
          class="ml-2 btn btn-sm btn-outline-secondary"
          @click="onClickPrint"
        >
          Imprimir
        </button>
      </template>
      <div class="form-row">
        <div class="col-lg-4">
          <div class="form-group">
            <label for="" class="form-label">Servicio</label>
            <InputSelect
              v-model="form.servicio"
              :options="containers.servicios"
              label="nombre"
              :reduce="(item) => item.idServicio"
              :getOptionKey="(opt) => opt.idServicio"
            >
            </InputSelect>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="form-group">
            <label for="" class="form-label">Fecha</label>
            <InputDatepicker
              v-model="form.fecha"
              input-class="form-control form-control-sm"
            ></InputDatepicker>
          </div>
        </div>
      </div>
      <div v-if="loading.header" class="text-center py-3">
        <span class="fa fa-fw fa-sync fa-spin"></span>
      </div>
      <div v-else class="form-row">
        <div class="col-lg-4">
          <label for="" class="form-label">Vehículo</label>
          <SelectMultipleList
            v-model="form.vehiculo"
            :options="containers.vehiculos"
            label="vehiculo"
            id="idVehiculo"
            :getOptionKey="(opt) => opt.idVehiculo"
            placeholder="Seleccione..."
          />
        </div>
        <div class="col-lg-4">
          <label for="" class="form-label">Guía</label>
          <SelectMultipleList
            v-model="form.guia"
            :options="containers.guias"
            label="nombre"
            id="idPersona"
            :getOptionKey="(opt) => opt.idPersona"
            placeholder="Seleccione..."
          />
        </div>
        <div class="col-lg-4">
          <label for="" class="form-label">Asistente</label>
          <SelectMultipleList
            v-model="form.asistente"
            :options="containers.asistentes"
            label="nombre"
            id="idPersona"
            :getOptionKey="(opt) => opt.idPersona"
            placeholder="Seleccione..."
          />
        </div>
      </div>
    </Card>
    <BibliaRegistros v-if="containers.biblia" :biblia="containers.biblia"></BibliaRegistros>
  </ui-content>
</template>
<script>
import BibliaRegistros from '../components/BibliaRegistros.vue';
import SelectMultipleList from '../../../components/SelectMultipleList.vue';
import InputDatepicker from '../../shared/components/InputDatepicker.vue';
import InputSelect from '../../shared/components/InputSelect.vue';
import Spinner from '../../shared/components/Spinner.vue';
import Card from '../../shared/components/Card.vue';
import pdfBibliaRegistros from '@/pdfs/pdfBibliaRegistros';
import { mapState } from 'vuex';

export default {
  components: {
    SelectMultipleList,
    Card,
    Spinner,
    InputSelect,
    InputDatepicker,
    SelectMultipleList,
    BibliaRegistros,
  },
  data() {
    return {
      servicio: null,
      fecha: this.$dayjs().format('YYYY-MM-DD'),
      vehiculo: [],
      guia: [],
      asistente: [],
      // flags
      registroSeleccionado: null,
      loadingRegistro: false,
      loadingView: true,
      clickItemEditar: false,

      // nueva forma
      form: {
        servicio: null,
        fecha: '',
        vehiculo: [],
        guia: [],
        asistente: [],
      },
      containers: {
        servicios: [],
        vehiculos: [],
        guias: [],
        asistentes: [],
        biblia: null,
        hoteles: [],
        agencias: [],
        restaurantes: [],
        hotelesHora: [],
        servicioTipos: [],
      },
      loading: {
        view: true,
        header: false,
        header_save: false,
      },
    };
  },
  async created() {
    let vm = this;
    let id_biblia = vm.$route.params?.id;
    let endpoint = vm.is_new ? '/biblias/nuevo' : `/biblias/${id_biblia}`;

    let response;

    try {
      response = await vm.axios.get(endpoint, {
        params: {
          containers: 1,
        },
      });
    } catch (error) {
      return vm.$router.push({ name: 'biblias' });
    }

    if (!vm.is_new) {
      vm.containers.biblia = response.data.content.biblia;
      vm.containers.hoteles = response.data.content.hoteles;
      vm.containers.agencias = response.data.content.agencias;
      vm.containers.restaurantes = response.data.content.restaurantes;
      vm.containers.hotelesHora = response.data.content.hotelesHora;
      vm.containers.servicioTipos = response.data.content.servicioTipos;

      if (vm.containers.biblia.idVehiculo1)
        vm.form.vehiculo.push(String(vm.containers.biblia.idVehiculo1));
      if (vm.containers.biblia.idVehiculo2)
        vm.form.vehiculo.push(String(vm.containers.biblia.idVehiculo2));
      if (vm.containers.biblia.idGuia1) vm.form.guia.push(String(vm.containers.biblia.idGuia1));
      if (vm.containers.biblia.idGuia2) vm.form.guia.push(String(vm.containers.biblia.idGuia2));
      if (vm.containers.biblia.idAsistente1)
        vm.form.asistente.push(String(vm.containers.biblia.idAsistente1));
      if (vm.containers.biblia.idAsistente2)
        vm.form.asistente.push(String(vm.containers.biblia.idAsistente2));

      vm.form.servicio = vm.containers.biblia.idServicio;
      vm.form.fecha = vm.containers.biblia.fecha;
    }

    vm.containers.servicios = response.data.content.servicios;
    vm.containers.vehiculos = response.data.content.vehiculos;
    vm.containers.guias = response.data.content.guias;
    vm.containers.asistentes = response.data.content.asistentes;

    vm.loading.view = false;

    vm.$watch('form.servicio', (newVal, oldVal) => {
      if (newVal) {
        vm.onChangeServicioFecha();
      }
    });

    vm.$watch('form.fecha', (newVal, oldVal) => {
      if (newVal) {
        vm.onChangeServicioFecha();
      }
    });
  },
  computed: {
    ...mapState('biblia_registros', {
      registros: (state) => state.list,
    }),
    is_new() {
      return this.$route.params?.id ? false : true;
    },
    resumen() {
      const vm = this;
      let servicio = vm.containers.servicios.find((item) => item.idServicio == vm.form.servicio);
      servicio = servicio.nombre ?? '';
      const fecha = vm.form.fecha ?? '';
      let vehiculos = [...vm.form.vehiculo];
      let registros = vm.registros ?? [];
      let recomendaciones = [];
      let observaciones = [];
      let asistencias = [];

      if (vehiculos.length) {
        let filtro = vm.containers.vehiculos.filter(
          (item) => vehiculos.indexOf(String(item.idVehiculo)) !== -1
        );
        filtro = filtro.map((item) => item.vehiculo);

        vehiculos = filtro.length ? filtro.join(' - ') : '';
      } else {
        vehiculos = '';
      }

      let guias = vm.form.guia;

      if (guias.length) {
        let filtro = vm.containers.guias.filter(
          (item) => guias.indexOf(String(item.idPersona)) !== -1
        );
        filtro = filtro.map((item) => item.nombre);

        guias = filtro.length ? filtro.join(' - ') : '';
      } else {
        guias = '';
      }

      let asistentes = vm.form.asistente;

      if (asistentes.length) {
        let filtro = vm.containers.asistentes.filter(
          (item) => asistentes.indexOf(String(item.idPersona)) !== -1
        );
        filtro = filtro.map((item) => item.nombre);

        asistentes = filtro.length ? filtro.join(' - ') : '';
      } else {
        asistentes = '';
      }

      recomendaciones = registros.filter((item) => (item.recomendacionesGuia ?? '').trim());
      observaciones = registros.filter((item) => (item.observacion ?? '').trim());
      asistencias = registros.filter((item) => (item.asistencia ?? '').trim());

      return {
        servicio,
        fecha,
        vehiculos,
        guias,
        asistentes,
        recomendaciones,
        observaciones,
        asistencias,
      };
    },
  },
  methods: {
    async onChangeServicioFecha() {
      let vm = this;

      if (!(vm.form.fecha && vm.form.servicio)) return;

      if (vm.loading.view == true) return;

      vm.form.vehiculo = [];
      vm.form.guia = [];
      vm.form.asistente = [];
      vm.containers.biblia = null;
      vm.loading.header = true;

      try {
        const response = await vm.axios.get(`/biblias`, {
          params: {
            'filter[idServicio]': vm.form.servicio,
            'filter[fecha]': vm.form.fecha,
          },
        });

        if (response.data.content) {
          vm.$router.push({
            name: 'biblias.registros',
            params: {
              id: response.data.content.idBiblia,
            },
          });
        } else {
          if (vm.$route.params?.id) {
            vm.$router.replace({ name: 'biblias.registros.nuevo' });
          }
        }
      } catch (error) {
        console.log({ error });
      } finally {
        vm.loading.header = false;
      }
    },
    onClickGuardarCabecera() {
      let vm = this;
      let fd = {
        servicio: vm.form.servicio,
        fecha: vm.form.fecha,
        vehiculo: vm.form.vehiculo,
        guias: vm.form.guia,
        asistentes: vm.form.asistente,
      };

      vm.loading.header_save = true;

      vm.axios
        .post('/biblias', fd)
        .then((response) => {
          vm.$toast.fire(response.data.message, '', 'success');
          vm.containers.biblia = {
            idBiblia: response.data.content.id,
            idServicio: fd.servicio,
            fecha: fd.fecha,
            registros: [],
          };

          vm.$router.replace({
            name: 'biblias.registros',
            params: {
              id: response.data.content.id,
            },
          });
        })
        .finally(() => {
          vm.loading.header_save = false;
        });
    },
    onClickPrint() {
      const vm = this;

      const registros = [...vm.registros].map((item) => {
        return {
          ...item,
          horaRecojo: item.horaRecojo ? vm.$dayjs(item.horaRecojo, 'HH:mm:ss').format('HH:mm') : '',
          enlaceTren: item.enlaceTren ? vm.$dayjs(item.enlaceTren, 'HH:mm:ss').format('HH:mm') : '',
          recojoPisac: item.recojoPisac === 'Sí' ? 'Sí' : '',
          estado: item.estado ? item.estado.substring(0, 4).toUpperCase() : '',
        };
      });

      pdfBibliaRegistros({
        registros: registros,
        resumen: {
          ...vm.resumen,
          fecha: vm.resumen.fecha ? vm.$dayjs(vm.resumen.fecha).format('DD-MM-YY') : '',
        },
        biblia: vm.containers.biblia,
        userMark: vm.$store.state.user,
        dateMark: vm.$dayjs().format('DD-MM-YY HH:mm'),
      });
    },
  },
};
</script>
